import { rootPath } from "./../Utils";

interface AddToHomeScreenOptions {
  appName: string;
  appIconUrl: string;
  assetUrl?: string;
  appNameDisplay?: "standalone" | "inline";
  displayOptions?: { showMobile?: boolean; showDesktop?: boolean };
  allowClose?: boolean;
  showArrow?: boolean;
}

interface AddToHomeScreenInstance {
  show(locale?: string): boolean;
  clearModalDisplayCount(): void;
}

declare global {
  interface Window {
    AddToHomeScreen?: (
      options: AddToHomeScreenOptions
    ) => AddToHomeScreenInstance;
  }
}

let instance: AddToHomeScreenInstance | undefined = undefined;

function getInstance(): AddToHomeScreenInstance | undefined {
  if (typeof window.AddToHomeScreen !== "function") return undefined;
  if (instance === undefined) {
    instance = window.AddToHomeScreen({
      appName: "My Flavoria",
      appIconUrl: `${rootPath}/logo192.png`,
      assetUrl: `${rootPath}/vendor/pwa-add-to-homescreen/assets/img/`,
      allowClose: true,
      showArrow: true,
    });
  }
  return instance;
}

export function showAddToHomeScreen(): boolean {
  const addToHomeScreen = getInstance();
  if (addToHomeScreen === undefined) return false;

  // The library has no Finnish locale (it would log a warning and fall back to
  // English anyway), so ask for English deterministically.
  return addToHomeScreen.show("en");
}
